import { Component, Vue, Prop } from "vue-property-decorator";
import axios from "axios";
import VueStore from "@/store/VueStore";
import router from "@/router";
import {
  MstMappingType,
  SensorStateType,
  AuthStoreType,
  lampColorsType,
  LampColorAndFlagMapType
} from "@/types/types";
import MstMappingService from "@/services/mst_mapping_service";
import AuthStoreAPI from "@/services/auth_store_service";
import IndexSignalMapping from "@/views/indexSignalMapping/IndexSignalMapping.vue";
import { RequestParamsMaker } from "./scripts/make_request_params";
import { applySignallampSetting } from "./scripts/apply_setting";
import { getLatestData } from "@/components/signalMapping/scripts/get_latest_sensor_data";
import { changeSignallMapFlash } from "@/components/signalMapping/scripts/change_singnallamp_flash";
import { getSignallampComponentSetting } from "@/components/signalMapping/scripts/get_signallamp_panel_settings";

@Component({
  components: {
    IndexSignalMapping
  }
})
export default class SignalMappingComponent extends Vue {
  @Prop() public mstMapping: MstMappingType;
  @Prop() public editFlag: boolean;
  public signallampID: number = null;
  public userID: string = JSON.parse(localStorage.getItem("iotKyotoAuth")).userName;
  public reloadEvent: any = null;
  // パトランプのマスター設定情報
  public mstSignallampSetting: any = null;
  public mstSignallampSettings: any = null;
  public dbTableName: string = null;
  public location: string = null;
  public lampColorAndFlagMap: LampColorAndFlagMapType[] = null;
  // パネル側のマスターコンポーネント情報
  public mstSignallampComponent: any = null;
  public deviceIds: string[] = null;
  public selectDeviceId: string = null;
  // 認証情報
  public authStores: AuthStoreType[] = null;
  public authStore: AuthStoreType = null;
  public authStoreName: string = null;
  // 表示設定
  public keyColors: string[] = null;
  public lampColors: lampColorsType[] = null;
  public noneFlash: boolean = false;
  public useAlertSound: boolean = false;
  public errorMassage: string = "";
  public backGroundAlertFlags: { [key: string]: boolean } = { red: false, yellow: false, blue: false, green: false, white: false };
  public timeZone: string =
    typeof JSON.parse(localStorage.getItem("graphSettings")).useTimeZone ===
      "undefined"
      ? "+09:00"
      : JSON.parse(localStorage.getItem("graphSettings")).useTimeZone;
  public sensorInfoArea: boolean = false;
  // 最新のパトランプデータ
  public latestSensorData: any = null;
  public latestDataDate: string = "";
  // 初回データ取得が失敗したかどうか
  public errorCheck: boolean = false;

  public async mounted() {
    try {
      if (this.latestDataDate === "") {
        this.latestDataDate = this.$t("message.notAcquired") as string;
      }
      if (VueStore.state.token === null) {
        return router.push("/signIn");
      }
      const userID: string = this.mstMapping.user_id;
      this.signallampID = this.mstMapping.mst_signallamp_id;
      const result: any | boolean = await getSignallampComponentSetting(this);
      if (result) {
        await this.getSignallampSettingData();
        this.authStores = await AuthStoreAPI.query(userID);
        applySignallampSetting(this);
        this.getAndApplyLatestSensorData();
        // 初回表示に問題がなければ5秒インターバルでデータ取得&表示処理を行う
        if (this.reloadEvent === null && !this.errorCheck) {
          this.reloadEvent = setInterval(() => {
            this.getAndApplyLatestSensorData();
          }, 5000);
        }
      }
    } catch (err) {
      console.log(err);
    }
  }

  public changeUseAlertSound() {
    this.useAlertSound = !this.useAlertSound;
  }

  /**
   * 最新のパトランプデータの取得および表示
   */
  private async getAndApplyLatestSensorData() {
    await getLatestData(this);
    changeSignallMapFlash(this, this.latestSensorData);
  }

  /**
   * ドラッグ終了時の位置を保存
   * @param x
   * @param y
   */
  public async onDragStop(x: number, y: number) {
    (this.mstMapping.sensor_state as SensorStateType).xPosition = x;
    (this.mstMapping.sensor_state as SensorStateType).yPosition = y;
    await MstMappingService.update(this.mstMapping);
  }

  /**
   * リサイズ操作終了時の設定を保存
   * @param x
   * @param y
   * @param w
   * @param h
   */
  public async onResizeStop(x: number, y: number, w: number, h: number) {
    (this.mstMapping.sensor_state as SensorStateType).xPosition = x;
    (this.mstMapping.sensor_state as SensorStateType).yPosition = y;
    (this.mstMapping.sensor_state as SensorStateType).width = w;
    (this.mstMapping.sensor_state as SensorStateType).height = h;
    await MstMappingService.update(this.mstMapping);
  }

  /**
   * パトランプ設定を取得(user_idとdevice_idで取得)
   */
  public async getSignallampSettingData() {
    const reqParams = await RequestParamsMaker.makeGetSignallampSettingDataParams(this.userID);
    const response = await axios(reqParams);
    this.mstSignallampSettings = response.data.res.mst_signallamp_setting;
    // 表示対象のdevice_idと一致する設定を適用
    for (const key in this.mstSignallampSettings) {
      if (this.mstSignallampSettings[key].device_id === this.selectDeviceId) {
        this.mstSignallampSetting = this.mstSignallampSettings[key];
        this.authStoreName = this.mstSignallampSetting.auth_store_name;
      }
    }
  }
  /**
   * パトランプ画面折りたたみ処理
   * トリガー実行時にパトランプ詳細画面が隠れている場合、開く。開いている場合、閉じる
   */
  public hideLampDetailsOrNot() {
    if (this.sensorInfoArea === false) {
      this.sensorInfoArea = true;
    } else {
      this.sensorInfoArea = false;
    }
  }
}
